import fuzzysort from 'fuzzysort'

export const search = <T>(items: T[], keys: string[], searchTerm: string) =>
  searchTerm ? fuzzysort.go(searchTerm, items, { keys }).map(({ obj }) => obj) : items
